export default "__VITE_PUBLIC_ASSET__41477a09__"